import personLayout from '../components/ordinary/index.vue'

const orderRouter = [
	{
		path: '/orderDetail', //父路由
		name: 'orderDetail',
		component: personLayout,
		children: [{
			path: '/orderDetail/deviceDetail',
			name: 'orderDetail/deviceDetail',
			component: () => import('../view/orderDetail/deviceDetail.vue'),
			meta: {
				title: '成套设备租赁详情'
			}
		}, {
			path: '/orderDetail/powerDetail',
			name: 'orderDetail/powerDetail',
			component: () => import('../view/orderDetail/powerDetail.vue'),
			meta: {
				title: '应急保电详情'
			}
		},{
			path: '/orderDetail/detail',
			name: 'orderDetail/detail',
			component: () => import('../view/orderDetail/detail.vue'),
			meta: {
				title: '应急保电详情'
			}
		}
		]
	}

]

export default orderRouter
